interface Props {
  visible: boolean;
  isLoginDisabled: boolean;
  Loading: boolean;
  onClick: () => void;
}

const LoginButton = ({ visible, isLoginDisabled, Loading, onClick }: Props) => (
  <button className={visible && !isLoginDisabled ? "btns1" : "btnsdisabled"} id="login" disabled={!visible || isLoginDisabled} onClick={onClick}>
    {Loading ? "Logging in..." : "Login"}
  </button>
);

export default LoginButton;
